import { styled } from '@mui/material/styles';

export const ModalBox = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 400,
  backgroundColor: theme.palette.background.paper,
  borderRadius: '8px',
  //border: '2px solid #000',
  boxShadow: theme.shadows[24],
  padding: theme.spacing(4),
  maxHeight: '90vh',
  overflowY: 'auto',
}));